export const defaultTokenState = () => ({
  id: null,
  countryCode: null,
})

export const createTokenSession = ({ access_token, country, account_id }) => {
  if (account_id) {
    return {
      id: account_id,
      accessToken: access_token,
      countryCode: country,
      accountId: account_id,
    }
  } else {
    return {
      id: access_token,
      accessToken: access_token,
      countryCode: country,
    }
  }
}

const getUserPremiumStatus = ({ benefitsInfo }) =>
  benefitsInfo.items &&
  benefitsInfo.items.find(
    ({ benefit }) =>
      benefit === 'cr_premium' ||
      benefit === 'cr_premium_plus' ||
      benefit === 'cr_fan_pack'
  )

const getUserAccessType = ({ benefitsInfo }) => {
  const isCrPremium =
    benefitsInfo.items &&
    benefitsInfo.items.find(({ benefit }) => benefit === 'cr_premium')
  const isCrPremiumPlus =
    benefitsInfo.items &&
    benefitsInfo.items.find(({ benefit }) => benefit === 'cr_premium_plus')
  const isFanPack =
    benefitsInfo.items &&
    benefitsInfo.items.find(({ benefit }) => benefit === 'cr_fan_pack')

  let accessType = null

  if (isFanPack) {
    accessType = isFanPack.benefit
  } else if (isCrPremiumPlus) {
    accessType = isCrPremiumPlus.benefit
  } else if (isCrPremium) {
    accessType = isCrPremium.benefit
  }

  return accessType
}

export const createUserSession = ({
  externalId,
  tokenInfo,
  accountInfo,
  profileInfo,
  eligibleInfo,
  benefitsInfo,
}) => {
  const isUserPremium = getUserPremiumStatus({ benefitsInfo })
  const accessType = getUserAccessType({ benefitsInfo })

  return {
    ...tokenInfo,
    externalId,
    isEmailVerified: accountInfo.email_verified || null,
    isAuthenticated: externalId !== null,
    isEligibleForFreeTrial: eligibleInfo.is_eligible || null,
    isUserPremium: isUserPremium ? true : false,
    subStatus: isUserPremium ? 'Premium' : 'Free',
    user: {
      id: externalId || null,
      etpGuid: accountInfo.account_id || null,
      created: accountInfo.created || null,
      username: profileInfo.username || null,
      email: profileInfo.email || null,
      avatar: profileInfo.avatar || null,
      eligible: eligibleInfo.is_eligible || null,
      benefits: benefitsInfo.items || null,
      premium: isUserPremium ? true : false,
      accessType,
      // New multi-profile fields
      profileId: profileInfo.profile_id || null,
      profileName: profileInfo.profile_name || null,
      profileType: profileInfo.profile_type || null,
      maturityRating: profileInfo.maturity_rating || null,
      extendedMaturityRating: profileInfo.extended_maturity_rating || null,
      preferredCommunicationLanguage: profileInfo.preferred_communication_language || null,
      preferredContentAudioLanguage: profileInfo.preferred_content_audio_language || null,
      preferredContentSubtitleLanguage: profileInfo.preferred_content_subtitle_language || null,
    },
    // Profile management fields
    profiles: profileInfo.profiles || null,
    maxProfiles: profileInfo.max_profiles || null,
    tierMaxProfiles: profileInfo.tier_max_profiles || null,
  }
}
